import { render } from "./newContracts.html?vue&type=template&id=5ac97d7c&scoped=true&ts=true&external"
import script from "./NewContracts.vue?vue&type=script&lang=ts"
export * from "./NewContracts.vue?vue&type=script&lang=ts"

import "./NewContracts.vue?vue&type=style&index=0&id=5ac97d7c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac97d7c"]])

export default __exports__